import { useContext, useMemo } from "react";
import { pluralizeWithCount } from "@common/helpers/string";
import { SegmentBar } from "@design-system/SegmentBar/SegmentBar";
import { Segment } from "@helpers/segment";
import invoiceStatsStyles from "@components/invoices/InvoiceStats.module.scss";
import { AccrualImporterContext } from "./accrualImporter.context";
import {
    getAccrualDocumentImportStatus,
    getAccrualLineItemExtraction,
} from "./accrualImporter.helpers";
import { AccrualImporterDocumentRow } from "./accrualImporter.types";

interface Props {
    rows: AccrualImporterDocumentRow[];
}

export const AccrualImporterStats: React.FC<Props> = ({ rows }) => {
    const { mode } = useContext(AccrualImporterContext);
    const noun = mode === "invoices" ? "invoice" : "bill";

    const segments = useMemo<Segment[]>(() => {
        const toReview = { total: 0, count: 0 };

        for (const row of rows) {
            if (getAccrualDocumentImportStatus(row).kind === "imported") {
                continue;
            }
            const amount = row.financialDocument
                ? getAccrualLineItemExtraction(row.financialDocument, mode)
                      ?.totalAmount
                : null;
            toReview.count += 1;
            toReview.total += amount ?? 0;
        }

        return [
            {
                id: "toReview",
                label: "To review",
                value: toReview.total,
                subtitle: pluralizeWithCount(noun, toReview.count),
                colors: {
                    start: "#E2F0FB",
                    end: "#94C9F1",
                    subtitle: "#115F9E",
                },
            },
        ];
    }, [mode, noun, rows]);

    return (
        <div className={invoiceStatsStyles.invoiceStatsContainer}>
            <SegmentBar
                className={invoiceStatsStyles.invoiceStats}
                segments={segments}
                formatValueAsMoney
            />
        </div>
    );
};
